import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhDropdownComponent } from './components/fh-dropdown.component';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FhInputPasswordModule } from '@fh-client-interaction-frontends/shared/ui/fh-password';
import { PasswordModule } from 'primeng/password';
import { FhLabelModule } from '@fh-client-interaction-frontends/fh-label';
import { InputTextModule } from 'primeng/inputtext';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    FhInputPasswordModule,
    PasswordModule,
    ReactiveFormsModule,
    FhLabelModule,
    InputTextModule,
    TranslateModule
  ],
  declarations: [FhDropdownComponent],
  exports: [FhDropdownComponent]
})
export class FhDropdownModule {}
